var dayOverride = 'fx_c76f37be_18910t50';
var dayText = 'fx_c76f37be_18910t51';

export { dayOverride, dayText };
//# sourceMappingURL=dayOverride.vanilla.mjs.map
